import ArticleDetail from "./ArticleDetail";
import ArticleList from "./ArticleList";
import Home from "./Home";
import Customization from "./Customization";
import CreateArticle from "./CreateArticle";
const routes = [
  {
    key: "home",
    route: "/",
    component: <Home />,
  },
  {
    key: "create_article",
    route: "/create_article",
    component: <CreateArticle />,
  },
   {
    key: "create_article",
    route: "/create_article/:categoryId",
    component: <CreateArticle />,
  },
  {
    key: "update_article",
    route: "/update_article/:articleId",
    component: <CreateArticle />,
  },
  {
    key: "sub_category_list",
    route: "/:categoryId",
    component: <ArticleList />,
  },
   {
    key: "article_detail",
    route: "/:categoryId/:articleId",
    component: <ArticleDetail />,
  },
   {
    key: "customization",
    route: "/customization",
    component: <Customization />,
  },
];

export default routes;
